import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Point } from '../../core/models';
import { PointService } from '../../core/services/point.service';
import { AppState } from '../../core/app-state';
import { FesBaseComponent } from '../../shared/components/fes-base.component';

@Component({
  selector: 'app-point-view',
  templateUrl: './point-view.component.html',
  styleUrls: ['./point-view.component.css']
})
export class PointViewComponent extends FesBaseComponent implements OnInit, OnDestroy {

  @Input('pointId') pointId : string
 
  public point : Point
  errorMsg = ''
  isLoading : boolean = false;

  constructor(private pointService : PointService, appState: AppState ) { 
    super(appState)
  }

  ngOnInit(): void {
    this.pointService.doWhenReady( () => this.loadPoint() )
  }

  ngOnDestroy(): void {
    this.destroy()
  }
  
  async loadPoint() {

    this.errorMsg = ""

    if ( !this.pointId ) {
      this.errorMsg = 'pointId is not set'
      return
    }

    try {
      this.isLoading = true
      const doc = await this.pointService.getById(this.pointId)
      this.point = doc?.toJSON()
      if ( !this.point ) {
        throw new Error("No point found for ID="+this.pointId)
      }  
    } catch ( error ) {
      this.errorMsg = this.pointService.extractErrorMsg(error)
    } finally {
      this.isLoading = false
    }
  }

}
